import badge from './badge.vue';
import text from './text.vue';
import date from './date';
import numeric from './numeric';

export default {
    badge,
    text,
    date,
    numeric,
};
